import { render, staticRenderFns } from "./RecipientInfoComponent.vue?vue&type=template&id=6ff367fb&"
import script from "./RecipientInfoComponent.vue?vue&type=script&lang=ts&"
export * from "./RecipientInfoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports